import DailyFerryDetail from "@/controllers/daily_ferry/daily-ferry-detail";

export default {
  extends: DailyFerryDetail,
  props: {
    pageTitle: String,
    navLabel: String
  }
}
